import AltArrowLeft from "@svg/new-design/alt-arrow-left";
import Link from "next/link";
import { FC, useState } from "react";
import Image from "next/image";
import { Button, BUTTON_SIZE, BUTTON_VARIANT } from "@shared/components/button";
import { homeCategories } from "../helpers/constants";

interface Props {
  withContainer?: boolean;
}
const HomeCategories: FC<Props> = ({ withContainer = true }) => {
  const [activeCategory, setActiveCategory] = useState<number | null>(null);

  return (
    <section className="lg:mb-12 pl-0 fds-sm:pl-4 xl:pl-0 ">
      <div className={withContainer ? "section-container mx-auto" : ""}>
        <div className="flex w-full items-center pl-4 md:pl-0 justify-between mb-5 lg:mb-8">
          {/* mobile title */}
          <span className="headline-md md:hidden">دسته‌بندی‌های منتخب</span>
          {/* desktop title */}
          <span className="headline-lg hidden md:block">
            موضوعات و دسته‌بندی‌های آموزشی منتخب
          </span>

          {/* mobile button */}
          <Button
            href="/explore"
            endIcon={<AltArrowLeft width={24} />}
            variant={BUTTON_VARIANT.TEXT_ACTION}
            size={BUTTON_SIZE.LARGE}
            className="md:hidden w-fit"
            linkClassName="md:hidden"
          >
            همه
          </Button>
          {/* desktop button */}
          <Button
            href="/explore"
            endIcon={<AltArrowLeft width={28} />}
            variant={BUTTON_VARIANT.TEXT_ACTION}
            size={BUTTON_SIZE.XLARGE}
            className="hidden md:flex"
            linkClassName="hidden md:flex"
          >
            همه دسته‌بندی‌ها
          </Button>
        </div>
        <div className="w-full grid grid-rows-2 fds-md:grid-cols-8  grid-flow-col overflow-x-scroll no-scrollbar gap-3 md:gap-x-2.5 md:gap-y-8 lg:gap-x-[22px] xl:gap-8">
          {homeCategories.map((item, index) => (
            <div
              key={item.id}
              onMouseEnter={() => setActiveCategory(index)}
              onMouseLeave={() => setActiveCategory(null)}
              className="inline-block h-fit"
            >
              <Link href={item.href} prefetch={false}>
                <div className="flex  flex-col items-center text-center w-full">
                  <div className="w-fds-68 md:w-[72px] lg:w-[88px] xl:w-[100px] aspect-square bg-fds-secondary hover:bg-fds-brand-light mb-2 md:mb-3 rounded-full flex justify-center items-center relative">
                    <div className="relative w-2/3 aspect-square">
                      <Image
                        src={
                          activeCategory === index
                            ? item.activeImage || item.image
                            : item.image
                        }
                        fill
                        alt={`تصویر ${item.name}`}
                        className={`${
                          activeCategory === index ? "fds-sm:scale-110" : ""
                        } transition-transform `}
                      />
                    </div>
                  </div>

                  {/* mobile label */}
                  <p className="title-sm lg:hidden block text-center whitespace-nowrap">
                    {item.mobileName}
                  </p>
                  {/* desktop label */}
                  <p className="title-md-medium lg:block hidden text-center">
                    {item.name}
                  </p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeCategories;
